module.exports = ".title-row {\n  padding-top: 75px; }\n\n.title-row-item a {\n  border-bottom: 1px solid rgba(235, 235, 235, 0.3);\n  display: block; }\n\n.title-row-item:last-child a {\n  border-bottom: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/row/title-row/title-row.styles.scss
// module id = 698
// module chunks = 2